import {component} from '../form/Constant'

export const parameterKeys = {
    heartRateLower: 'heartRateLower',
    heartRateUpper: 'heartRateUpper',

    respirationLower: 'respirationLower',
    respirationUpper: 'respirationUpper',

    temperatureLower: 'temperatureLower',
    temperatureUpper: 'temperatureUpper',

    systolicLower: 'systolicLower',
    systolicUpper: 'systolicUpper',

    oxygenLower: 'oxygenLower',
    oxygenUpper: 'oxygenUpper',

    glucoseLower: 'glucoseLower',
    glucoseUpper: 'glucoseUpper',

    stepsLower: 'stepsLower',
    stepsUpper: 'stepsUpper',

    sleepLower: 'sleepLower',
    sleepUpper: 'sleepUpper',

    comment: 'comment',
}

export const parameterValue = {
    heartRate: 'BPM',
    temperature: '°C',
    systolic: 'mm/Hg',
    oxygen: '%',
    glucose: 'mmol/L',
    steps: 'steps',
    sleep: ' hr',
    beatsPerMinute: 'Beats per minute',
    breathsPerMinute: 'Breaths per minute',
}

export const parameterRange = {
    heartRate: {
        min: 20,
        max: 220,
        lowerDefaultValue: 41,
        upperDefaultValue: 110,
    },
    respiration: {
        min: 1,
        max: 50,
        lowerDefaultValue: 9,
        upperDefaultValue: 20,
    },
    temperature: {
        min: 27,
        max: 43,
        lowerDefaultValue: 35,
        upperDefaultValue: 39,
    },
    systolic: {
        min: 40,
        max: 250,
        lowerDefaultValue: 101,
        upperDefaultValue: 219,
    },
    oxygen: {
        min: 50,
        max: 100,
        lowerDefaultValue: 94,
        upperDefaultValue: 101,
    },
    glucose: {
        min: 0,
        max: 30,
        lowerDefaultValue: 4,
        upperDefaultValue: 9,
    },
    steps: {
        min: 0,
        max: 20000,
        lowerDefaultValue: 500,
        upperDefaultValue: 15000,
    },
    sleep: {
        min: 0,
        max: 24,
        lowerDefaultValue: 4,
        upperDefaultValue: 8,
    },
}

export const parameterList = [
    {
        key: 'Parameter Form',
        description:
            "Fill in the information showing the range of a person's health indicators",
        note: 'If you change the OBS indicators for a patient that is not in the range of the Parameter health indicators, the system will notify you.',
        children: [
            {
                key: parameterKeys.heartRateLower,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.heartRate,
                min: parameterRange.heartRate.min,
                max: parameterRange.heartRate.max,
                defaultValue: parameterRange.heartRate.lowerDefaultValue,
            },
            {
                key: parameterKeys.heartRateUpper,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.heartRate,
                min: parameterRange.heartRate.min,
                max: parameterRange.heartRate.max,
                defaultValue: parameterRange.heartRate.upperDefaultValue,
            },
            {
                key: parameterKeys.respirationLower,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.heartRate,
                min: parameterRange.respiration.min,
                max: parameterRange.respiration.max,
                defaultValue: parameterRange.respiration.lowerDefaultValue,
            },
            {
                key: parameterKeys.respirationUpper,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.heartRate,
                min: parameterRange.respiration.min,
                max: parameterRange.respiration.max,
                defaultValue: parameterRange.respiration.upperDefaultValue,
            },
            {
                key: parameterKeys.temperatureLower,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.temperature,
                min: parameterRange.temperature.min,
                max: parameterRange.temperature.max,
                step: 0.1,
                defaultValue: parameterRange.temperature.lowerDefaultValue,
            },
            {
                key: parameterKeys.temperatureUpper,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.temperature,
                min: parameterRange.temperature.min,
                max: parameterRange.temperature.max,
                step: 0.1,
                defaultValue: parameterRange.temperature.upperDefaultValue,
            },
            {
                key: parameterKeys.systolicLower,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                min: parameterRange.systolic.min,
                max: parameterRange.systolic.max,
                shorten: parameterValue.systolic,
                defaultValue: parameterRange.systolic.lowerDefaultValue,
            },
            {
                key: parameterKeys.systolicUpper,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                min: parameterRange.systolic.min,
                max: parameterRange.systolic.max,
                shorten: parameterValue.systolic,
                defaultValue: parameterRange.systolic.upperDefaultValue,
            },
            {
                key: parameterKeys.oxygenLower,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.oxygen,
                min: parameterRange.oxygen.min,
                max: parameterRange.oxygen.max,
                defaultValue: parameterRange.oxygen.lowerDefaultValue,
            },
            {
                key: parameterKeys.oxygenUpper,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.oxygen,
                min: parameterRange.oxygen.min,
                max: parameterRange.oxygen.max,
                defaultValue: parameterRange.oxygen.upperDefaultValue,
            },
            {
                key: parameterKeys.glucoseLower,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.glucose,
                min: parameterRange.glucose.min,
                max: parameterRange.glucose.max,
                step: 0.1,
                defaultValue: parameterRange.glucose.lowerDefaultValue,
            },
            {
                key: parameterKeys.glucoseUpper,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.glucose,
                min: parameterRange.glucose.min,
                max: parameterRange.glucose.max,
                step: 0.1,
                defaultValue: parameterRange.glucose.upperDefaultValue,
            },
            {
                key: parameterKeys.stepsLower,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.steps,
                min: parameterRange.steps.min,
                max: parameterRange.steps.max,
                defaultValue: parameterRange.steps.lowerDefaultValue,
            },
            {
                key: parameterKeys.stepsUpper,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.steps,
                min: parameterRange.steps.min,
                max: parameterRange.steps.max,
                defaultValue: parameterRange.steps.upperDefaultValue,
            },
            {
                key: parameterKeys.sleepLower,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.sleep,
                min: parameterRange.sleep.min,
                max: parameterRange.sleep.max,
                defaultValue: parameterRange.sleep.lowerDefaultValue,
            },
            {
                key: parameterKeys.sleepUpper,
                component: component.slider,
                className: 'col-12 sm:col-6 md:col-6 lg:col-6 ',
                shorten: parameterValue.sleep,
                min: parameterRange.sleep.min,
                max: parameterRange.sleep.max,
                defaultValue: parameterRange.sleep.upperDefaultValue,
            },
            {
                key: parameterKeys.comment,
                component: component.inputTextArea,
                placeholder: 'Input your comment here...',
            },
        ],
    },
]
